<template>
    <div class="background-dark">
        <div class="block no-internet">
            <div class="no-internet__img"></div>
            <article>{{ $t("translation.noInternet") }}</article>
            <h2>{{ $t("translation.connectToInternet") }}</h2>

            <div class="mt-3 d-flex justify-content-center flex-column flex-sm-row">
                <router-link :to="{ name: 'workspace' }" class="btn btn-outline-primary mr-0 mr-sm-2 mb-2 mb-sm-0">
                    {{ $t("translation.iWantProgram") }}
                </router-link>
                <button class="btn btn-outline-primary">
                    {{ $t("translation.tryAgain") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default  {
    };
</script>



// WEBPACK FOOTER //
// src/components/pop-up/NoInternet.vue